export default __webpack_public_path__ + "static/media/homepage_groove.c0672a1b.svg";